import { AnalyticsEventName } from '../types';

export interface SearchAnalyticsEventParams {
  query?: string;
  searchType?: string;
}

export const sendSearchAnalyticsEvent = (
  params: SearchAnalyticsEventParams = {},
) => {
  const { query = '', searchType = 'pure search' } = params;

  mitGTM.sendEvent({
    event: AnalyticsEventName.SEARCH,
    search: {
      search_term: query.trim(),
      method: searchType.toLowerCase(),
    },
  });
};

export interface ViewSearchResultsAnalyticsEventParams
  extends SearchAnalyticsEventParams {
  resultsNumber: number;
}

export const sendViewSearchResultsAnalyticsEvent = (
  params: ViewSearchResultsAnalyticsEventParams,
) => {
  const { query = '', searchType = 'pure search', resultsNumber } = params;

  mitGTM.sendEvent({
    event: AnalyticsEventName.VIEW_SEARCH_RESULTS,
    search: {
      search_term: query.trim(),
      method: searchType.toLowerCase(),
      results: resultsNumber,
    },
  });
};
